/**
 * MobileConstellationLogo - Elegant particle constellation logo for mobile
 *
 * Replaces the simple "T" logo with an animated constellation pattern
 * matching the FloatingResearchBubble aesthetic.
 *
 * Features:
 * - Static constellation by default
 * - Subtle particle animation on interaction
 * - Transcend navy gradient background
 */
import React from 'react';
import './MobileConstellationLogo.css';

function MobileConstellationLogo({ size = 'medium', onClick }) {
  const sizeClass = `constellation-logo-${size}`;

  return (
    <button
      className={`mobile-constellation-logo ${sizeClass}`}
      onClick={onClick}
      aria-label="Transcend Home"
    >
      <svg viewBox="0 0 40 40" className="constellation-svg">
        <defs>
          <linearGradient id="mobileLogoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#1a2744" />
            <stop offset="100%" stopColor="#2C3E50" />
          </linearGradient>
          <radialGradient id="mobileLogoGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="white" stopOpacity="0.15" />
            <stop offset="100%" stopColor="white" stopOpacity="0" />
          </radialGradient>
        </defs>

        {/* Background with rounded corners */}
        <rect x="2" y="2" width="36" height="36" rx="8" ry="8" fill="url(#mobileLogoGrad)" />

        {/* Subtle inner glow */}
        <circle cx="20" cy="20" r="14" fill="url(#mobileLogoGlow)" className="inner-glow" />

        {/* Constellation network */}
        <g className="constellation-nodes">
          {/* Central node - larger, brighter */}
          <circle cx="20" cy="18" r="2.5" fill="white" fillOpacity="0.95" className="node-center" />

          {/* Primary outer nodes */}
          <circle cx="11" cy="11" r="1.8" fill="white" fillOpacity="0.8" className="node-primary" />
          <circle cx="29" cy="11" r="1.8" fill="white" fillOpacity="0.8" className="node-primary" />
          <circle cx="11" cy="27" r="1.5" fill="white" fillOpacity="0.7" className="node-secondary" />
          <circle cx="29" cy="27" r="1.5" fill="white" fillOpacity="0.7" className="node-secondary" />

          {/* Accent nodes - smaller, subtler */}
          <circle cx="20" cy="28" r="1.2" fill="white" fillOpacity="0.6" className="node-accent" />
          <circle cx="15" cy="14" r="1" fill="white" fillOpacity="0.5" className="node-accent" />
          <circle cx="25" cy="14" r="1" fill="white" fillOpacity="0.5" className="node-accent" />
        </g>

        {/* Connecting lines */}
        <g className="constellation-lines">
          <line x1="11" y1="11" x2="20" y2="18" stroke="white" strokeWidth="0.8" strokeOpacity="0.35" />
          <line x1="29" y1="11" x2="20" y2="18" stroke="white" strokeWidth="0.8" strokeOpacity="0.35" />
          <line x1="11" y1="27" x2="20" y2="18" stroke="white" strokeWidth="0.6" strokeOpacity="0.25" />
          <line x1="29" y1="27" x2="20" y2="18" stroke="white" strokeWidth="0.6" strokeOpacity="0.25" />
          <line x1="20" y1="18" x2="20" y2="28" stroke="white" strokeWidth="0.5" strokeOpacity="0.2" />
          <line x1="11" y1="11" x2="29" y2="11" stroke="white" strokeWidth="0.4" strokeOpacity="0.15" />
        </g>
      </svg>
    </button>
  );
}

export default MobileConstellationLogo;
